import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { LandingPage } from '@/components/landing/LandingPage';
import { LoadingScreen } from '@/components/shared/LoadingScreen';

// Split por rota: a landing pública não baixa o bundle do painel autenticado.
const PanelRoutes = lazy(() => import('@/app/PanelRoutes'));
const LoginPage = lazy(() =>
  import('@/pages/LoginPage').then((m) => ({ default: m.LoginPage })),
);
const SetPasswordPage = lazy(() =>
  import('@/pages/SetPasswordPage').then((m) => ({ default: m.SetPasswordPage })),
);
const VerificarReciboPage = lazy(() =>
  import('@/pages/VerificarReciboPage').then((m) => ({ default: m.VerificarReciboPage })),
);

export default function App() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/set-password" element={<SetPasswordPage />} />
        <Route path="/verificar-recibo/:numeroRecibo" element={<VerificarReciboPage />} />
        <Route path="/app/*" element={<PanelRoutes />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
